<template>
  <div class="container-fluid">
    <consult-note-print
      v-if="isCreated"
      :selectedPatient="selectedPatient"
      :generalConfig="general"
      :selectedConsultNote="selectedConsultNote"
      :patientConfig="patient"
    />
  </div>
</template>

<script>
import ConsultNotePrint from '@/components/Print/ConsultNotePrint.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'PatientConsultNote',
  components: {
    ConsultNotePrint,
  },
  data() {
    return {
      isCreated: false,
      selectedConsultNote: {},
    };
  },
  computed: {
    ...mapGetters('patient', ['selectedPatient']),
    ...mapGetters('config', ['general', 'patient']),
  },
  async created() {
    const vm = this;
    let vuex = await window.store.getters.vuex.storage.getItem('vuex');
    if (typeof vuex !== 'object') {
      vuex = JSON.parse(vuex);
    }
    vm.selectedConsultNote = Object.assign({}, vuex.note.print); /* eslint-disable-line no-restricted-globals */
    this.isCreated = true;
  },
};
</script>
